import Vue from 'vue'
import App from './App'
import store from './store'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import ElementUI from 'element-ui';
Vue.use(ElementUI)
import animated from 'wowjs/css/libs/animate.css';
Vue.use(animated);
import 'swiper/css/swiper.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/init.css';
import chushihuazihao from '@/assets/js/font.js';
// console.log(chushihuazihao())
import '@/assets/css/style.css';
import '@/assets/css/wapstyle.css';
import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import countTo from 'vue-count-to';
Vue.component('countTo',countTo);

import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
Vue.component('IOdometer',IOdometer);

const config = require('@/../vue.config');

import {removeByIndex,getTime,router_url,screenHeight,hasBtn} from './utils/index'
import wowPlugin from './utils/wow'
Vue.use(wowPlugin);
import {get,post,put,export_blob,del} from './api/index'

import header from '@/components/views/header';
Vue.component('header_html',header);
import footer from '@/components/views/footer';
Vue.component('footer_html',footer);
import banner from '@/components/views/banner';
Vue.component('banner',banner);
import about from '@/components/views/about';
Vue.component('about',about);

// var table_height=screenHeight();
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
// Vue.prototype.table_height = table_height
Vue.prototype.screenHeight = screenHeight
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$export_blob = export_blob
Vue.prototype.$del = del

import i18n from './utils/i18n/i18n';
var lang = localStorage.getItem('lang') || 'cn';
i18n.locale = lang;

if(lang=='cn'){
	document.title = config.API_TITLE;
}else{
	document.title = config.API_TITLE_EN;
}




import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
  	vuescroll:{wheelScrollDuration:200 },
		bar: {background: "#c1c1c1", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
  name: 'vueScroll'
});
import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js